module.exports = __webpack_public_path__ + "img/search-button.31d96151.svg";